import React, { useMemo, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import './ZakatPage.css';

export const ZakatPage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useLanguage();
  const [cash, setCash] = useState('');
  const [gold, setGold] = useState('');
  const [silver, setSilver] = useState('');

  const zakatDue = useMemo(() => {
    const total = (parseFloat(cash) || 0) + (parseFloat(gold) || 0) + (parseFloat(silver) || 0);
    return total * 0.025;
  }, [cash, gold, silver]);

  return (
    <div className="zakat-page" style={{ backgroundColor: colors.background, color: colors.text }}>
      <h2>{t.more.zakat}</h2>
      <p className="subtitle" style={{ color: colors.muted }}>{t.more.zakatDesc}</p>

      <div className="calculator-card" style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}>
        <div className="input-group">
          <label style={{ color: colors.muted }}>{t.more.cashSavings}</label>
          <input
            type="number"
            value={cash}
            onChange={(e) => setCash(e.target.value)}
            placeholder="0.00"
            style={{ backgroundColor: colors.background, color: colors.text, borderColor: colors.border }}
          />
        </div>

        <div className="input-group">
          <label style={{ color: colors.muted }}>{t.more.goldValue}</label>
          <input
            type="number"
            value={gold}
            onChange={(e) => setGold(e.target.value)}
            placeholder="0.00"
            style={{ backgroundColor: colors.background, color: colors.text, borderColor: colors.border }}
          />
        </div>

        <div className="input-group">
          <label style={{ color: colors.muted }}>{t.more.silverValue}</label>
          <input
            type="number"
            onChange={(e) => setSilver(e.target.value)}
            placeholder="0.00"
            style={{ backgroundColor: colors.background, color: colors.text, borderColor: colors.border }}
          />
        </div>

        <div className="result-card" style={{ backgroundColor: colors.tint }}>
          <div className="result-label">{t.more.zakatTotal}</div>
          <div className="result-value">${zakatDue.toFixed(2)}</div>
        </div>

        <p className="disclaimer" style={{ color: colors.muted }}>{t.more.nisabNote}</p>
      </div>
    </div>
  );
};
